import { AccentVariantEnum } from '@delmonicos/shared-design-system-react/src/components/accent-icon/accent-icon';
import { Card } from '@delmonicos/shared-design-system-react/src/components/card/card';
import { GapEnum } from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { AccentTitle } from '@delmonicos/shared-design-system-react/src/components/typography/title/accent-title/accent-title';
import { HeadingEnum } from '@delmonicos/shared-design-system-react/src/models/enums/heading.enum';
import { GatewayNetworkModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/networks/models/outputs/gateway-network.model';
import { useTranslation } from 'react-i18next';

interface NetworkCustomerDetailsProps {
  customer: GatewayNetworkModel['customer'];
}

export const NetworkCustomerDetails = ({
  customer,
}: NetworkCustomerDetailsProps): React.JSX.Element => {
  const { t } = useTranslation();

  return (
    <Card gap={GapEnum.L}>
      <AccentTitle
        icon="dataflow-04"
        variant={AccentVariantEnum.Secondary}
        as={HeadingEnum.H2}
        text={t('delmonicos-shared-sdk.outputs-network.customer')}
      />
      <div>{customer?.name ?? '-'}</div>
    </Card>
  );
};
